var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("SimpleTextPopup", {
    attrs: { title: _vm.$t("warehouseRates"), hideRgtBtn: "", large: "" },
    on: {
      popupClose: function($event) {
        return _vm.$emit("input", false)
      }
    },
    scopedSlots: _vm._u([
      {
        key: "input",
        fn: function() {
          return [
            _c(
              "v-container",
              { attrs: { fluid: "" } },
              [
                _c("v-layout", { staticClass: "headline" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("VIPDiscount")) +
                      ":  \n        "
                  ),
                  JSON.stringify(_vm.discount) !== "{}"
                    ? _c("span", { staticClass: "text-capitalize" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.discount.name) +
                            " (" +
                            _vm._s(_vm.discount.discountRate) +
                            "%)\n        "
                        )
                      ])
                    : _c("span", { staticClass: "text-capitalize" }, [
                        _vm._v("\n          N/A\n        ")
                      ])
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c("BillingSettingsDisplay", {
              attrs: {
                displayMode: true,
                selectedWarehouseLimitedInfo: _vm.selectedWarehouseLimitedInfo
              }
            })
          ]
        },
        proxy: true
      }
    ]),
    model: {
      value: _vm.value,
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2756a808", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2756a808","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/WarehouseRatesPopup.vue
// module id = null
// module chunks = 